
// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import { LanguageContext } from "App";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { useContext, useState } from "react";
import { SelectedUserContext } from "../../index";

import MDInput from "components/MDInput";
import Select from 'react-select';
import Swal from "sweetalert2";
import UserManagementApi from "../../../../../Classes/API/Administration/UserManagementApi";
import CreateUserReq from "../../../../../Classes/Models/Requests/Users/CreateUserReq";
import './style.scss';
function index({ setEditMode }) {
    const User = useContext(SelectedUserContext)
    const [Gender, setGender] = useState(User.gender);
    const {translations} = useContext(LanguageContext)

    const EditUserClick = async () => {
        let editReq = new CreateUserReq();
        editReq.Id = User.id;
        editReq.Nationality = User.nationality;
        editReq.NationalityGroup = User.nationalityGroup;
        editReq.Name = document.getElementById("name").value;
        editReq.Address = document.getElementById("address").value;
        editReq.Number = document.getElementById("phone").value;
        editReq.Age = document.getElementById("age").value;
        editReq.FoundBy = document.getElementById("foundBy").value;
        editReq.Gender = Gender;
        editReq.NationalId = document.getElementById("nationalId").value;
        editReq.RelativeNumber = document.getElementById("relativeNumber").value;
        editReq.AccreditedPartners = document.getElementById("accreditedPartners").value;
        editReq.ChronicDiseases = document.getElementById("chronicDiseases").value;
        editReq.Sensitivity = document.getElementById("sensitivity").value;
        editReq.Medications = document.getElementById("medications").value;



        let res = await UserManagementApi.EditUser(editReq);
        if (res.status == "Success") {
            Swal.fire("Success", res.message, "success");
            setEditMode(false);
            window.location.reload();
        }
        else {
            Swal.fire("Error", res.message, "error");
        }

    }
    const GetGenderOptions = () => {
        debugger
        if (User.gender) {
            if (User.gender == "male") {
                return GenderOptions[0];
            }
            if (User.gender == "female") {
                return GenderOptions[1];
            }
        }
    }
    const GenderOptions = [
        { value: 'male', label: 'male' },
        { value: 'female', label: 'female' }
    ]

    return (
        <Card sx={{ height: "100%", boxShadow: !false && "none" }}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
                <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                   {translations.userManagementInfoUserSettingUserInfo}
                </MDTypography>
                <MDTypography variant="body2" color="secondary">
                    <Tooltip placement="top" onClick={() => setEditMode(false)}>
                        <Icon>edit</Icon>
                    </Tooltip>
                </MDTypography>
            </MDBox>
            <MDBox p={2}>
                <MDBox className="user-info-grid">
                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoUserId} &nbsp;
                        </MDTypography>
                        <MDTypography variant="button" fontWeight="regular" color="text">
                            &nbsp;{User.id}
                        </MDTypography>
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoName} &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.name} id="name" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoUserAge} &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.age} id="age" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoFoundBy} &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.foundBy} id="foundBy" />
                    </MDBox>

                    <MDBox >
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfogender}: &nbsp;
                        </MDTypography>
                        <MDBox className="select-gender" display="flex" alignItems="center">
                            <Select
                                onChange={(e) => setGender(e.value)}
                                defaultValue={GetGenderOptions()}
                                options={GenderOptions}
                                className="custom-select" // Applying the custom class
                            />
                        </MDBox>

                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoNationalID} &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.nationalId} id="nationalId" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoRelativeNumber}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.relativeNumber} id="relativeNumber" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoAccreditedPartners}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.accreditedPartners} id="accreditedPartners" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoChronicDiseases}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.chronicDiseases} id="chronicDiseases" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoSensitivity}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.sensitivity} id="sensitivity" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoMedications}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.medications} id="medications" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoNationalityGroup}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.nationalityGroup} id="nationalityGroup" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserSettingUserInfoPhone}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.number} id="phone" />
                    </MDBox>

                    <MDBox className="info-item">
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementPgTableElementsAddress}: &nbsp;
                        </MDTypography>
                        <MDInput variant="standard" defaultValue={User.address} id="address" />
                    </MDBox>

                    <MDBox className="info-item" justifyContent="flex-end">
                        <button onClick={() => { EditUserClick() }} className="btn btn-primary">Save</button>
                    </MDBox>
                </MDBox>
            </MDBox>
        </Card>

    );
}

export default index;
